import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AppLayout } from '@/components/AppLayout'
import { AnalyticsListener } from '@/components/AnalyticsListener'
import { RequireAuth } from '@/components/RequireAuth'
import { LoginPage } from '@/pages/LoginPage'
import { CompleteAuthPage } from '@/pages/CompleteAuthPage'
import { ServicesPage } from '@/pages/ServicesPage'
import { BatteryAdvicePage } from '@/pages/BatteryAdvicePage'
import { DataExportPage } from '@/pages/DataExportPage'
import { SolarGuardPage } from '@/pages/SolarGuardPage'
import { DesignPreviewPage } from '@/pages/DesignPreviewPage'
import { ProgramLandingPage } from '@/pages/ProgramLandingPage'
import { ProgramsOverviewPage } from '@/pages/ProgramsOverviewPage'
import { TermsPage } from '@/pages/TermsPage'
import { PROGRAM_TERMS } from '@/content/terms/netBewustThuisLaden'
import { DATA_SHARING_TERMS } from '@/content/terms/netBewustDataSharing'
import {
  CHARGEE_ENTITY,
  NET_BEWUST_DATA_SHARING_PATH,
  NET_BEWUST_TERMS_PATH,
} from '@/content/terms/types'
import { programsEnabled } from '@/lib/programs'

export default function App() {
  return (
    <BrowserRouter>
      <AnalyticsListener />
      <AppLayout>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/auth/complete" element={<CompleteAuthPage />} />
          <Route
            path="/services"
            element={
              <RequireAuth>
                <ServicesPage />
              </RequireAuth>
            }
          />
          <Route
            path="/services/battery-advice"
            element={
              <RequireAuth>
                <BatteryAdvicePage />
              </RequireAuth>
            }
          />
          <Route
            path="/services/data-export"
            element={
              <RequireAuth>
                <DataExportPage />
              </RequireAuth>
            }
          />
          <Route
            path="/services/solar-guard"
            element={
              <RequireAuth>
                <SolarGuardPage />
              </RequireAuth>
            }
          />
          {programsEnabled && (
            <>
              {/* Public: anyone can read what they would agree to before logging in. */}
              <Route
                path={NET_BEWUST_TERMS_PATH}
                element={
                  <TermsPage
                    document={PROGRAM_TERMS}
                    related={[
                      { label: DATA_SHARING_TERMS.title, href: NET_BEWUST_DATA_SHARING_PATH },
                      { label: 'Algemene Voorwaarden van Chargee', href: CHARGEE_ENTITY.terms },
                      { label: 'Privacyverklaring van Chargee', href: CHARGEE_ENTITY.privacy },
                    ]}
                  />
                }
              />
              <Route
                path={NET_BEWUST_DATA_SHARING_PATH}
                element={
                  <TermsPage
                    document={DATA_SHARING_TERMS}
                    related={[
                      { label: PROGRAM_TERMS.title, href: NET_BEWUST_TERMS_PATH },
                      { label: 'Privacyverklaring van Chargee', href: CHARGEE_ENTITY.privacy },
                      { label: 'Algemene Voorwaarden van Chargee', href: CHARGEE_ENTITY.terms },
                    ]}
                  />
                }
              />
              <Route
                path="/programs"
                element={
                  <RequireAuth>
                    <ProgramsOverviewPage />
                  </RequireAuth>
                }
              />
              <Route
                path="/programs/:slug"
                element={
                  <RequireAuth>
                    <ProgramLandingPage />
                  </RequireAuth>
                }
              />
            </>
          )}
          {/* TEMPORARY design-preview routes; removed before release. */}
          <Route path="/design-preview" element={<DesignPreviewPage />} />
          <Route path="/design-preview/wizard" element={<DesignPreviewPage fresh />} />
          <Route path="/design-preview/dashboard" element={<ServicesPage />} />
          <Route path="/" element={<Navigate to="/services" replace />} />
          <Route path="*" element={<Navigate to="/services" replace />} />
        </Routes>
      </AppLayout>
    </BrowserRouter>
  )
}
